import React from "react";
import { ScrollViewProps } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";

export const KeyboardAwareFlashListScrollComponent: React.FC<
  ScrollViewProps
> = (props) => {
  return <KeyboardAwareScrollView {...props} />;
};
